import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { AvatarWithMessageComponent } from '@shared/avatar-with-message/avatar-with-message.component';
import { AvatarSubtitle, AvatarTitle, RotatePosition } from '@shared/avatar-with-message/avatar-with-message.constants';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-efficient-accounting-integration',
    imports: [NgOptimizedImage, AssetPipe, ContentWrapperComponent, AvatarWithMessageComponent, RouterLink],
    templateUrl: './efficient-accounting-integration.component.html',
    styleUrl: './efficient-accounting-integration.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EfficientAccountingIntegrationComponent {
    public readonly efficientAccountingItems: string[] = [
        $localize`:@@efficient-accounting-enable-seamless:Enable Seamless Financial Data Management`,
        $localize`:@@efficient-accounting-enable-easy:Enable easy invoice generation and expense tracking within the app`,
        $localize`:@@efficient-accounting-ensure:Ensure compliance with accounting standards and regulations`,
    ];

    public readonly boxImages = [
        {
            name: 'screen',
            className: 'mt-75px tab:hidden mob:hidden',
            width: 527,
            height: 354,
        },
        {
            name: 'screen-tab',
            width: 341,
            height: 553,
            className: 'mt-75px desk:hidden mob:hidden',
        },
        {
            name: 'screen-mob',
            width: 393,
            height: 378,
            className: 'mt-40px desk:hidden tab:hidden',
        },
    ];

    public readonly avatarTitle = AvatarTitle.HI_I_AM_AN;
    public readonly avatarSubtitle = AvatarSubtitle.ACCOUNTANT;
    public readonly avatarPosition = RotatePosition.ZERO_DEG;
}
